import {Component, Input} from '@angular/core';
import {ErrorCodes} from "../../enums/states/error-codes";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'analytics-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.css'],
  imports: [
    CommonModule
  ]
})
export class ErrorMessageComponent {

  @Input() public analysisErrorState: ErrorCodes | undefined;

  protected readonly undefined = undefined;
  protected readonly ErrorAnalysis = ErrorCodes;
}
